// Cart Note Handler
// Handles updating cart note field via AJAX

(function() {
  'use strict';

  let debounceTimer;
  const DEBOUNCE_DELAY = 1000; // Wait 1 second after user stops typing

  function initCartNote() {
    const cartNoteField = document.getElementById('cart-note');
    
    if (!cartNoteField) {
      return; // Cart note field not present on this page
    }

    // Debounced update function
    function updateCartNote() {
      const noteValue = cartNoteField.value;
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          note: noteValue
        })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Cart note updated successfully');
        // Dispatch custom event for other parts of the theme to listen to
        document.dispatchEvent(new CustomEvent('cart:note:updated', {
          detail: { cart: cart }
        }));
      })
      .catch(error => {
        console.error('Error updating cart note:', error);
      });
    }

    // Listen for input changes with debouncing
    cartNoteField.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateCartNote, DEBOUNCE_DELAY);
    });

    // Also update on blur (when user clicks away)
    cartNoteField.addEventListener('blur', function() {
      clearTimeout(debounceTimer);
      updateCartNote();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNote);
  } else {
    initCartNote();
  }
})();

